interface LoaderState {
    loading: boolean;
    displayLoader: boolean;
}

type LoaderAction = 'loading' | 'loaded' | 'display';

// Logic for deplayed loading indicators
export function loaderReducer(loaderState: LoaderState, action: LoaderAction) {
    switch (action) {
        case 'loading':
            return { loading: true, displayLoader: loaderState.displayLoader };
        case 'loaded':
            return { loading: false, displayLoader: false };
        case 'display':
            if (loaderState.loading) {
                return { loading: true, displayLoader: true };
            }
            return { loading: false, displayLoader: false };
        default:
            throw new Error();
    }
}
